"use client"

import {useEffect, useMemo, useState} from "react";
import {useOptionalCompanyId} from "@/hooks/use-company-id";
import {useOwnCompanies} from "@/hooks/queries/use-users";
import {LastOpenedCompanyKey} from "@/app/components/RememberCompany";

export function usePreferredCompany() {
  const companyId = useOptionalCompanyId()
  const companies = useOwnCompanies()
  const [rememberedCompanyId, setRememberedCompanyId] = useState<number | undefined>(undefined)

  useEffect(() => {
    const storedCompanyId = localStorage.getItem(LastOpenedCompanyKey)
    setRememberedCompanyId(storedCompanyId ? parseInt(storedCompanyId) : undefined)
  }, [])

  return useMemo(() => {
    const preferredCompanyId = companyId ?? rememberedCompanyId ?? companies[0]?.id
    const preferredCompany = companies.find(company => company.id === preferredCompanyId) ?? companies[0]
    return {
      preferredCompanyId: preferredCompany?.id,
      preferredCompany,
    }
  }, [companies, companyId, rememberedCompanyId])
}
